import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'xui-mat-email-card',
    templateUrl: './app-mat-email-card.component.html',
    styleUrls: ['./app-mat-email-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule]
})
export class AppMatEmailCardComponent {
    readonly email = input<string | undefined>();

    get emailAddress(): string {
        const email = this.email();
        return (email && email.length) ? email : 'Not specified';
    }
}
